import { API_BASE_URL, API_BUSINESS_URL } from '@/utils';
import type { RootState } from '@/store/store';

let ENABLE_GPS_TRACKER_MOCK = false;

interface RoutePoint {
  lat: number;
  lng: number;
  name: string;
  course?: number;
  speed?: number;
}

const ROUTE_POINTS: RoutePoint[] = [
  {
    lat: -34.87211478300095,
    lng: -56.20144287338787,
    name: 'Plaza Independencia (inicio)',
    course: 180,
    speed: 30.0, // 30 km/h - arranque suave
  }, //1
  {
    lat: -34.872125250712095,
    lng: -56.19968853726792,
    name: 'Av. 18 de Julio y Ejido',
    course: 180,
    speed: 40.0, // 40 km/h - velocidad normal
  }, //2
  {
    lat: -34.87193683170783,
    lng: -56.19708574040632,
    name: 'Av. 18 de Julio y Yí',
    course: 180,
    speed: 45.0, // 45 km/h - velocidad normal
  }, //3
  {
    lat: -34.871758880018454,
    lng: -56.19471898148127,
    name: 'Av. 18 de Julio y Río Branco',
    course: 180,
    speed: 40.0, // 40 km/h - velocidad normal
  }, //4
  {
    lat: -34.87161756517602,
    lng: -56.19274136621879,
    name: 'Av. 18 de Julio y Colonia',
    course: 180,
    speed: 36.0, // 36 km/h - velocidad normal
  }, //5
  {
    lat: -34.871528589039514,
    lng: -56.1914144501717,
    name: 'Av. 18 de Julio y Mercedes',
    course: 180,
    speed: 40.0, // 40 km/h - velocidad normal
  }, //6
  {
    lat: -34.8712927115208,
    lng: -56.18813903917384,
    name: 'Av. 18 de Julio y Arenal Grande',
    course: 180,
    speed: 45.0, // 45 km/h - velocidad normal
  }, //7
  {
    lat: -34.871110239748845,
    lng: -56.185493194355224,
    name: 'Av. 18 de Julio y Bulevar Artigas',
    course: 180,
    speed: 40.0, // 40 km/h - velocidad normal
  }, //8
  {
    lat: -34.87091218620924,
    lng: -56.182692968148835,
    name: 'Av. 18 de Julio y Av. Italia',
    course: 180,
    speed: 36.0, // 36 km/h - velocidad normal
  }, //9
  {
    lat: -34.87084616825716,
    lng: -56.18180783917619,
    name: 'Av. 18 de Julio (punto adicional 1)',
    course: 180,
    speed: 30.0, // 30 km/h - reduciendo velocidad
  }, //10
  {
    lat: -34.87067454629507,
    lng: -56.179442092179166,
    name: 'Av. 18 de Julio (punto adicional 2)',
    course: 180,
    speed: 20.0, // 20 km/h - frenando antes del giro
  }, //11
  {
    lat: -34.870494096578945,
    lng: -56.17689399362153,
    name: 'Av. 18 de Julio (punto adicional 3)',
    course: 180,
    speed: 10.0, // 10 km/h - casi detenido antes del giro
  }, //12
  {
    lat: -34.87026523295468,
    lng: -56.17334811331292,
    name: 'Parque Batlle (fin)',
    course: 180,
    speed: 0.0,
  }, //12 - detenido
  {
    lat: -34.87026523295468,
    lng: -56.17334811331292,
    name: 'Parque Batlle (fin)',
    course: 225,
    speed: 0.0,
  }, //13 - girando
  {
    lat: -34.87026523295468,
    lng: -56.17334811331292,
    name: 'Parque Batlle (fin)',
    course: 270,
    speed: 0.0,
  }, //14 - girando
  {
    lat: -34.87026523295468,
    lng: -56.17334811331292,
    name: 'Parque Batlle (fin)',
    course: 315,
    speed: 5.0, // 5 km/h - empezando a acelerar
  }, //15 - empezando a acelerar
  {
    lat: -34.87026523295468,
    lng: -56.17334811331292,
    name: 'Parque Batlle (fin)',
    course: 0,
    speed: 10.0, // 10 km/h - acelerando
  }, //16 - acelerando
  {
    lat: -34.870494096578945,
    lng: -56.17689399362153,
    name: 'Av. 18 de Julio (punto adicional 3)',
    course: 0,
    speed: 20.0, // 20 km/h - acelerando después del giro
  }, //12
  {
    lat: -34.87067454629507,
    lng: -56.179442092179166,
    name: 'Av. 18 de Julio (punto adicional 2)',
    course: 0,
    speed: 30.0, // 30 km/h - ganando velocidad
  }, //11
  {
    lat: -34.87084616825716,
    lng: -56.18180783917619,
    name: 'Av. 18 de Julio (punto adicional 1)',
    course: 0,
    speed: 36.0, // 36 km/h - velocidad normal
  }, //10

  {
    lat: -34.87091218620924,
    lng: -56.182692968148835,
    name: 'Av. 18 de Julio y Av. Italia',
    course: 0,
    speed: 40.0, // 40 km/h - velocidad normal
  }, //9
  {
    lat: -34.871110239748845,
    lng: -56.185493194355224,
    name: 'Av. 18 de Julio y Bulevar Artigas',
    course: 0,
    speed: 45.0, // 45 km/h - velocidad normal
  }, //8
  {
    lat: -34.8712927115208,
    lng: -56.18813903917384,
    name: 'Av. 18 de Julio y Arenal Grande',
    course: 0,
    speed: 40.0, // 40 km/h - velocidad normal
  }, //7
  {
    lat: -34.871528589039514,
    lng: -56.1914144501717,
    name: 'Av. 18 de Julio y Mercedes',
    course: 0,
    speed: 36.0, // 36 km/h - velocidad normal
  }, //6
  {
    lat: -34.87161756517602,
    lng: -56.19274136621879,
    name: 'Av. 18 de Julio y Colonia',
    course: 0,
    speed: 40.0, // 40 km/h - velocidad normal
  }, //5
  {
    lat: -34.871758880018454,
    lng: -56.19471898148127,
    name: 'Av. 18 de Julio y Río Branco',
    course: 0,
    speed: 45.0, // 45 km/h - velocidad normal
  }, //4
  {
    lat: -34.87193683170783,
    lng: -56.19708574040632,
    name: 'Av. 18 de Julio y Yí',
    course: 0,
    speed: 40.0, // 40 km/h - velocidad normal
  }, //3
  {
    lat: -34.872125250712095,
    lng: -56.19968853726792,
    name: 'Av. 18 de Julio y Ejido',
    course: 0,
    speed: 36.0, // 36 km/h - reduciendo para llegar
  }, //2
  {
    lat: -34.87211478300095,
    lng: -56.20144287338787,
    name: 'Plaza Independencia (inicio)',
    course: 0,
    speed: 30.0, // 30 km/h - llegando
  }, //1
  {
    lat: -34.87211478300095,
    lng: -56.20144287338787,
    name: 'Plaza Independencia (inicio)',
    course: 45,
    speed: 20.0, // 20 km/h - girando
  }, //1
  {
    lat: -34.87211478300095,
    lng: -56.20144287338787,
    name: 'Plaza Independencia (inicio)',
    course: 90,
    speed: 10.0, // 10 km/h - girando
  }, //1
  {
    lat: -34.87211478300095,
    lng: -56.20144287338787,
    name: 'Plaza Independencia (inicio)',
    course: 135,
    speed: 5.0, // 5 km/h - casi detenido
  }, //1
];

const ROUTE_POINTS_2: RoutePoint[] = [
  {
    lat: -34.34677083915317,
    lng: -56.72602095853468,
    name: 'Punto 1',
    course: 180,
    speed: 35.0,
  }, // subiendo
  {
    lat: -34.34606218539849,
    lng: -56.72228732367264,
    name: 'Punto 2',
    course: 180,
    speed: 42.0,
  },
  {
    lat: -34.34496376024225,
    lng: -56.71730914385657,
    name: 'Punto 3',
    course: 180,
    speed: 45.0,
  },
  {
    lat: -34.34448540930565,
    lng: -56.714326527501264,
    name: 'Punto 4',
    course: 180,
    speed: 40.0,
  },
  {
    lat: -34.34450312605567,
    lng: -56.714605477232325,
    name: 'Punto 5',
    course: 180,
    speed: 38.0,
  },
  {
    lat: -34.34305034012284,
    lng: -56.70698800380688,
    name: 'Punto 6',
    course: 180,
    speed: 43.0,
  },
  {
    lat: -34.342093613690295,
    lng: -56.70143046685705,
    name: 'Punto 7',
    course: 180,
    speed: 40.0,
  },
  {
    lat: -34.34083567899283,
    lng: -56.695014623042375,
    name: 'Punto 8',
    course: 180,
    speed: 35.0,
  },
  // giro en el punto 8
  {
    lat: -34.34083567899283,
    lng: -56.695014623042375,
    name: 'Punto 8',
    course: 225,
    speed: 10.0, // frenando antes del giro
  },
  {
    lat: -34.34083567899283,
    lng: -56.695014623042375,
    name: 'Punto 8',
    course: 270, // girando
    speed: 0.0,
  },
  {
    lat: -34.34083567899283,
    lng: -56.695014623042375,
    name: 'Punto 8',
    course: 315, // girando
    speed: 0.0,
  },
  {
    lat: -34.34083567899283,
    lng: -56.695014623042375,
    name: 'Punto 8',
    course: 0, // girando
    speed: 5.0, // empezando a acelerar
  },
  {
    lat: -34.34083567899283,
    lng: -56.695014623042375,
    name: 'Punto 8',
    course: 0, // acelerando en dirección de vuelta
    speed: 10.0,
  },
  // ahora bajando
  {
    lat: -34.342093613690295,
    lng: -56.70143046685705,
    name: 'Punto 7',
    course: 0,
    speed: 30.0,
  },
  {
    lat: -34.34305034012284,
    lng: -56.70698800380688,
    name: 'Punto 6',
    course: 0,
    speed: 38.0,
  },
  {
    lat: -34.34450312605567,
    lng: -56.714605477232325,
    name: 'Punto 5',
    course: 0,
    speed: 40.0,
  },
  {
    lat: -34.34448540930565,
    lng: -56.714326527501264,
    name: 'Punto 4',
    course: 0,
    speed: 42.0,
  },
  {
    lat: -34.34496376024225,
    lng: -56.71730914385657,
    name: 'Punto 3',
    course: 0,
    speed: 45.0,
  },
  {
    lat: -34.34606218539849,
    lng: -56.72228732367264,
    name: 'Punto 2',
    course: 0,
    speed: 40.0,
  },
  {
    lat: -34.34677083915317,
    lng: -56.72602095853468,
    name: 'Punto 1',
    course: 0,
    speed: 35.0,
  },
  {
    lat: -34.34677083915317,
    lng: -56.72602095853468,
    name: 'Punto 1',
    course: 45,
    speed: 35.0,
  },
  {
    lat: -34.34677083915317,
    lng: -56.72602095853468,
    name: 'Punto 1',
    course: 90,
    speed: 35.0,
  },
  {
    lat: -34.34677083915317,
    lng: -56.72602095853468,
    name: 'Punto 1',
    course: 135,
    speed: 35.0,
  },
  {
    lat: -34.34677083915317,
    lng: -56.72602095853468,
    name: 'Punto 1',
    course: 180,
    speed: 35.0,
  },
];

interface DriverState {
  currentIndex: number;
  previousIndex: number;
  routePoints: RoutePoint[];
  driverId: string;
  deviceId: string;
}

const DRIVER_1_STATE: DriverState = {
  currentIndex: 0,
  previousIndex: ROUTE_POINTS.length - 1,
  routePoints: ROUTE_POINTS,
  driverId: '82d17f0b-f536-4328-b93a-c11b1e0630be',
  deviceId: 'e73b38a7-d4e7-4e6d-b04f-4c1b3ee51fb9',
};

const DRIVER_2_STATE: DriverState = {
  currentIndex: 0,
  previousIndex: ROUTE_POINTS_2.length - 1,
  routePoints: ROUTE_POINTS_2,
  driverId: '1ca1bce3-de28-4e6e-aefd-e9976ea8182f',
  deviceId: '82d17f0b-f536-4328-b93a-c11b1e0630be',
};

const calculateCourse = (from: RoutePoint, to: RoutePoint): number => {
  const dLng = to.lng - from.lng;
  const dLat = to.lat - from.lat;
  const angle = Math.atan2(dLng, dLat) * (180 / Math.PI);
  return angle < 0 ? angle + 360 : angle;
};

const getNextRoutePoint = (
  driverState: DriverState
): {
  point: RoutePoint;
  currentIndex: number;
  previousIndex: number;
} => {
  const currentPoint = driverState.routePoints[driverState.currentIndex];

  const result = {
    point: currentPoint,
    currentIndex: driverState.currentIndex,
    previousIndex: driverState.previousIndex,
  };

  driverState.previousIndex = driverState.currentIndex;
  driverState.currentIndex =
    (driverState.currentIndex + 1) % driverState.routePoints.length;

  return result;
};

const getMockGpsTrackerData = (driverState: DriverState) => {
  const { point: routePoint, previousIndex } = getNextRoutePoint(driverState);

  let course: number;
  let speed: number;

  if (routePoint.course !== undefined) {
    course = routePoint.course;
  } else {
    const previousPoint = driverState.routePoints[previousIndex];
    course = calculateCourse(previousPoint, routePoint);
  }

  if (routePoint.speed !== undefined) {
    speed = routePoint.speed;
  } else {
    speed = 30.0;
  }

  return {
    accuracy: 3.7899999618530273,
    altitude: 118.9000015258789,
    appVersion: '1.0.0 (1)',
    batteryLevel: 1.0,
    course: course,
    deviceId: driverState.deviceId,
    driverId: driverState.driverId,
    isCharging: true,
    lat: routePoint.lat,
    lng: routePoint.lng,
    mode: 'OPERATE_ONLY',
    networkType: 'WIFI',
    provider: 'gps',
    speed: speed,
    status: 'AVAILABLE',
    timestamp: Date.now(),
  };
};

const sendDriverTrack = async (
  driverState: DriverState,
  token: string | null
): Promise<void> => {
  try {
    const mockData = getMockGpsTrackerData(driverState);
    const url = `${API_BASE_URL}/gps-tracker/track`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
      },
      body: JSON.stringify(mockData),
    });

    if (!response.ok) {
    }
  } catch (error) {}
};

export const sendMockGpsTrackerTrack = async (
  getState: () => RootState
): Promise<void> => {
  if (!ENABLE_GPS_TRACKER_MOCK) {
    return;
  }

  try {
    const state = getState();
    const token = state.auth.auth.accessToken;
    await Promise.all([
      sendDriverTrack(DRIVER_1_STATE, token),
      sendDriverTrack(DRIVER_2_STATE, token),
    ]);
  } catch (error) {}
};

export const fetchDriverNameFromAPI = async (
  driverId: string,
  token: string | null
): Promise<{ firstName?: string; lastName?: string }> => {
  try {
    const url = `${API_BUSINESS_URL}/drivers/${driverId}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    });

    if (response.ok) {
      const data = await response.json();
      return {
        firstName: data.firstName || data.name,
        lastName: data.lastName,
      };
    }
  } catch (error) {}
  return {};
};

export const isGpsTrackerMockEnabled = (): boolean => {
  return ENABLE_GPS_TRACKER_MOCK;
};

export const setGpsTrackerMockEnabled = (enabled: boolean): void => {
  ENABLE_GPS_TRACKER_MOCK = enabled;
};

export const toggleGpsTrackerMock = (): boolean => {
  ENABLE_GPS_TRACKER_MOCK = !ENABLE_GPS_TRACKER_MOCK;
  return ENABLE_GPS_TRACKER_MOCK;
};
